import React from "react";
import "./HoroscopesGrid.scss";
import { HoroscopesTile } from "../HoroscopesTile/HoroscopesTile";
import { HoroscopeIconType } from "../HoroscopesIcon/HoroscopesIcon-Constants";

interface HoroscopesGridProps {
  onSignSelect?: (sign: HoroscopeIconType) => void;
}

export const HoroscopesGrid: React.FC<HoroscopesGridProps> = ({
  onSignSelect,
}) => {
  const signs: HoroscopeIconType[] = Object.values(HoroscopeIconType);

  const handleSignClick = (sign: HoroscopeIconType) => {
    if (onSignSelect) {
      onSignSelect(sign);
    }
  };

  return (
    <div className="horoscopes-grid" data-testid="horoscopes-grid">
      {signs.map((sign) => {return (
        <HoroscopesTile
          key={sign}
          sign={sign}
          onClick={() => {return handleSignClick(sign)}}
        />
      )})}
    </div>
  );
};
